import { render, staticRenderFns } from "./StrGostergeGirisiTablo.vue?vue&type=template&id=32152e52"
import script from "./StrGostergeGirisiTablo.vue?vue&type=script&lang=js"
export * from "./StrGostergeGirisiTablo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports